import { Picture } from './picture.interface';
import { Station } from './station.class';
import { User } from './user.class';

export class Issue {
  static get states(): any[] {
    return [
      { key: 'todo', label: 'A faire', },
      { key: 'estimateDone', label: 'Devis fait', },
      { key: 'estimateValidated', label: 'Devis validé', },
      { key: 'done', label: 'Fait', },
      { key: 'abandoned', label: 'Abandonné', },
    ];
  }

  public static getStateLabel(key) {
    const state = Issue.states.find((state) => state.key === key);

    return (state && state.label) || 'Inconnu';
  }

  public id?: string;
  public date?: Date;
  public description?: string;
  public pictures: Picture[];
  public StationId: string;
  public ById: string;
  public By?: User;
  public Station?: Station;
  public stateLabel: string;
  private _state: string;

  constructor(obj?: any) {
    const data = {
      state: 'created',
      pictures: [],
      ...(obj || {})
    };

    this.id = data.id;
    this.state = data.state;
    this.date = new Date(data.date);
    this.description = data.description;
    this.StationId = data.StationId;
    this.ById = data.ById;
    this.pictures = data.pictures ? data.pictures.map((picture) => {
      if(typeof picture === 'string') return { id: picture };
      else return picture;
    }) : [];

    if (data.Station) {
        this.Station = new Station(data.Station);
    }

    if (data.By) {
        this.By = new User(data.By);
    }
  }

  get state() {
    return this._state;
  }

  set state(newState: string) {
    this._state = newState;
    this.stateLabel = Issue.getStateLabel(newState);
  }

  public toJSON() {
    return {
      id: this.id,
      state: this.state,
      date: this.date,
      pictures: this.pictures,
      description: this.description,
      StationId: this.StationId,
      ById: this.ById,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/models/issue.class.ts